"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getliaotianrole = exports.userLogoutApi = void 0;
/**
 * @description 退出登录
 * @param params
 * @return {Promise<unknown>|Promise<undefined>|*}
 */
var hview_http_1 = require("@hview/hview-http");
var userLogoutApi = function () { return hview_http_1.default.post("/addons/ask/api.user/logout"); };
exports.userLogoutApi = userLogoutApi;
var getliaotianrole = function (params) { return hview_http_1.default.post("/api/v2/doctor/Customform/getliaotianrole", params); };
exports.getliaotianrole = getliaotianrole;
